import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { fetchPredictorEditor } from '../../actions/predictorEditor';
import {
    PredictorExpander,
    PredictorExpanderProps
} from '../../components/PredictorExpander/PredictorExpander';
import {
    selectPredictorEditor,
    selectPredictorEditorIndoorData,
    selectPredictorEditorOutdoorData
} from '../../selectors/groupEdit/group/group';
import { MapType } from '../../typings/displayMap';
import { GroupId } from '../../typings/groups';
import { TextPredictor } from '../../typings/predictor';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    mapType: MapType;
}

type StateProps = TStateProps<PredictorExpanderProps, OwnProps>;
type DispatchProps = TDispatchProps<PredictorExpanderProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { mapType } = ownProps;
    let listData: TextPredictor[] = [];
    let groupId: GroupId = '';

    if (mapType === MapType.outdoor) {
        groupId = state.outdoorMapEditor.groupId;
        listData = selectPredictorEditorOutdoorData(state, groupId);
    } else {
        groupId = state.indoorMapEditor.groupId;
        listData = selectPredictorEditorIndoorData(state, groupId);
    }

    const {
        id,
        detailed,
        basic,
        isLoading,
        error,
        otsDetailed,
        otsBasic
    } = selectPredictorEditor(state, groupId);

    return {
        text: listData,
        id,
        sum: basic,
        detailed,
        isLoading,
        error,
        isGrowPerformanceEnabled: false,
        otsDetailed,
        otsBasic,
        isOutdoor: mapType === MapType.outdoor
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { mapType } = ownProps;
    return {
        updatePredictor: () => {
            dispatch(fetchPredictorEditor(mapType));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps
): PredictorExpanderProps => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

export const PredictorExpanderMapContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PredictorExpanderProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PredictorExpander);
